var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { serializer, transformError, resolveQueryFieldsTransformationPaths, } from '@wix/metro-runtime/velo';
import * as ambassadorWixMarketingMarketingConsentV1MarketingConsent from '@wix/ambassador-marketing-marketing-consent-v1-marketing-consent/http';
// @ts-ignore
import { wrapWithQueryBuilder } from '@wix/motion-edm-autogen-query-wrapper';
const _toVeloEntity = '$';
const _fromVeloEntity = '$';
export var MarketingConsentDetailsIdentifierType;
(function (MarketingConsentDetailsIdentifierType) {
    MarketingConsentDetailsIdentifierType["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    MarketingConsentDetailsIdentifierType["EMAIL"] = "EMAIL";
    MarketingConsentDetailsIdentifierType["PHONE"] = "PHONE";
})(MarketingConsentDetailsIdentifierType || (MarketingConsentDetailsIdentifierType = {}));
export var MarketingConsentState;
(function (MarketingConsentState) {
    /** State of the marketing consent is unknown. */
    MarketingConsentState["UNKNOWN_STATE"] = "UNKNOWN_STATE";
    /** The site visitor never confirmed to receive marketing consents. */
    MarketingConsentState["NEVER_CONFIRMED"] = "NEVER_CONFIRMED";
    /** The marketing consent has been removed, for example, when a site visitor unsubscribes from a newsletter. */
    MarketingConsentState["REVOKED"] = "REVOKED";
    /** The marketing consent is pending confirmation. Relevant only for `{"optInLevel": "DOUBLE_CONFIRMATION"}`. */
    MarketingConsentState["PENDING"] = "PENDING";
    /** The site visitor has confirmed their marketing consent. */
    MarketingConsentState["CONFIRMED"] = "CONFIRMED";
})(MarketingConsentState || (MarketingConsentState = {}));
export var Source;
(function (Source) {
    Source["UNKNOWN_SOURCE"] = "UNKNOWN_SOURCE";
    Source["IN_PERSON"] = "IN_PERSON";
    Source["FORM"] = "FORM";
    Source["LINK_CONFIRMATION"] = "LINK_CONFIRMATION";
    Source["EMAIL_SERVICE"] = "EMAIL_SERVICE";
    Source["WIX_USERS"] = "WIX_USERS";
    Source["OTHER"] = "OTHER";
})(Source || (Source = {}));
export var OptInLevel;
(function (OptInLevel) {
    OptInLevel["UNKNOWN_OPT_IN_LEVEL"] = "UNKNOWN_OPT_IN_LEVEL";
    OptInLevel["SINGLE_CONFIRMATION"] = "SINGLE_CONFIRMATION";
    OptInLevel["DOUBLE_CONFIRMATION"] = "DOUBLE_CONFIRMATION";
})(OptInLevel || (OptInLevel = {}));
export var LastRevokeActivitySource;
(function (LastRevokeActivitySource) {
    LastRevokeActivitySource["UNKNOWN_SOURCE"] = "UNKNOWN_SOURCE";
    LastRevokeActivitySource["IN_PERSON"] = "IN_PERSON";
    LastRevokeActivitySource["FORM"] = "FORM";
    LastRevokeActivitySource["REVOKE_LINK"] = "REVOKE_LINK";
    LastRevokeActivitySource["OTHER"] = "OTHER";
})(LastRevokeActivitySource || (LastRevokeActivitySource = {}));
export var LinkType;
(function (LinkType) {
    LinkType["UNKNOWN_LINK_TYPE"] = "UNKNOWN_LINK_TYPE";
    LinkType["CONFIRMATION"] = "CONFIRMATION";
    LinkType["REVOKE_CONFIRMATION"] = "REVOKE_CONFIRMATION";
})(LinkType || (LinkType = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
const _bulkUpsertMarketingConsentRequest = {};
const _bulkUpsertMarketingConsentResponse = {};
const _createMarketingConsentByTokenRequest = {};
const _createMarketingConsentByTokenResponse = {};
const _createMarketingConsentRequest = {};
const _createMarketingConsentResponse = {};
const _deleteMarketingConsentRequest = {};
const _deleteMarketingConsentResponse = {};
const _generateLinkRequest = {};
const _generateLinkResponse = {};
const _getConsistentMarketingConsentByIdentifierRequest = {};
const _getConsistentMarketingConsentByIdentifierResponse = {};
const _getMarketingConsentByIdentifierRequest = {};
const _getMarketingConsentByIdentifierResponse = {};
const _getMarketingConsentRequest = {};
const _getMarketingConsentResponse = {};
const _queryMarketingConsentRequest = {};
const _queryMarketingConsentResponse = {};
const _removeMarketingConsentByTokenRequest = {};
const _removeMarketingConsentByTokenResponse = {};
const _removeMarketingConsentRequest = {};
const _removeMarketingConsentResponse = {};
const _updateMarketingConsentRequest = {};
const _updateMarketingConsentResponse = {};
const _upsertMarketingConsentRequest = {};
const _upsertMarketingConsentResponse = {};
/**
 * Retrieves a marketing consent.
 * @param marketingConsentId - Marketing consent ID.
 * @public
 * @documentationMaturity preview
 * @requiredField marketingConsentId
 * @permissionId MARKETING.CONSENT_READ
 * @adminMethod
 * @returns The requested marketing consent.
 */
export function getMarketingConsent(marketingConsentId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { marketingConsentId: '$[0]' };
        const responseTransformation = '$.marketingConsent';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getMarketingConsentRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getMarketingConsentResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['marketingConsent']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([marketingConsentId]);
        const reqOpts = ambassadorWixMarketingMarketingConsentV1MarketingConsent.getMarketingConsent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'marketingConsentId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a marketing consent by its details.
 * Required fields:
 * - `details.type`.
 * - `details.email` OR `details.phone`.
 *
 * >**Note:** Due to the ongoing development of our new documentation portal, the query parameter is not displaying as expected. Use the `details` object located in the marketing consent object in the request. You can also see the code example for reference.
 * @param type - The communication channel of the marketing consent.
 * @public
 * @documentationMaturity preview
 * @requiredField type
 * @param options - Field options. The relevant `email` or `phone` **must** be passed.
 * @permissionId MARKETING.CONSENT_READ
 * @adminMethod
 */
export function getMarketingConsentByIdentifier(type, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            type: '$[0]',
            email: '$[1].email',
            phone: '$[1].phone',
            linkLanguage: '$[1].linkLanguage',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getMarketingConsentByIdentifierRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getMarketingConsentByIdentifierResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['marketingConsent']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([type, options]);
        const reqOpts = ambassadorWixMarketingMarketingConsentV1MarketingConsent.getMarketingConsentByIdentifier(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'type',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/** @param type - The communication channel of the marketing consent.
 * @internal
 * @documentationMaturity preview
 * @requiredField type
 * @permissionId MARKETING.CONSENT_READ_CONSISTENT
 * @adminMethod
 */
export function getConsistentMarketingConsentByIdentifier(type, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            type: '$[0]',
            email: '$[1].email',
            phone: '$[1].phone',
            linkLanguage: '$[1].linkLanguage',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _getConsistentMarketingConsentByIdentifierRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _getConsistentMarketingConsentByIdentifierResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['marketingConsent']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([type, options]);
        const reqOpts = ambassadorWixMarketingMarketingConsentV1MarketingConsent.getConsistentMarketingConsentByIdentifier(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'type',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates a confirmed marketing consent with a `state` of `CONFIRMED`.
 * Required fields:
 * - `details.type`.
 * - `details.email` OR `details.phone`.
 * - `lastConfirmationActivity`.
 *
 * To create a marketing consent with a different state, use Upsert Marketing Consent, or Bulk Upsert Marketing Consent.
 * @param marketingConsent - Marketing consent to create.
 * @public
 * @documentationMaturity preview
 * @requiredField marketingConsent
 * @requiredField marketingConsent.details
 * @requiredField marketingConsent.lastConfirmationActivity
 * @permissionId MARKETING.CONSENT_UPSERT
 * @adminMethod
 * @returns Newly created marketing consent.
 */
export function createMarketingConsent(marketingConsent) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { marketingConsent: '$[0]' };
        const responseTransformation = '$.marketingConsent';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createMarketingConsentRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['marketingConsent']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createMarketingConsentResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['marketingConsent']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([marketingConsent]);
        const reqOpts = ambassadorWixMarketingMarketingConsentV1MarketingConsent.createMarketingConsent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'marketingConsent',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Updates a marketing consent.
 * Required fields:
 * - `details.type`.
 * - `details.email` OR `details.phone`.
 * - `state`.
 *
 * When a marketing consent's `state` is `PENDING` or `CONFIRMED`, the `info.lastConfirmationActivity` field is required.
 * When a marketing consent's `state` is `REVOKED`, the `info.lastRevokeActivity` field is required.
 *
 * >**Note:** For existing marketing consents with `{"type": "EMAIL"}`, you can't update the `state` to `UNKNOWN_STATE`. Trying to do so maintains the current state. However, you can create a new marketing consent and set the `state` to `UNKNOWN_STATE`. Note that you can't create more than a single consent per email or phone number.
 * @param _id - Marketing consent ID.
 * @public
 * @documentationMaturity preview
 * @requiredField _id
 * @requiredField options.marketingConsent.details
 * @param options - Field options. The following fields **must** be passed: `details.type`, the relevant `email` OR `phone`, and `state`.
 * @permissionId MARKETING.CONSENT_UPDATE
 * @adminMethod
 * @returns Updated marketing consent.
 */
export function updateMarketingConsent(_id, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            marketingConsent: { '*': '$[1].marketingConsent', id: '$[0]' },
            mask: '$[1].mask',
        };
        const responseTransformation = '$.marketingConsent';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _updateMarketingConsentRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['marketingConsent']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _updateMarketingConsentResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['marketingConsent']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([_id, options]);
        const reqOpts = ambassadorWixMarketingMarketingConsentV1MarketingConsent.updateMarketingConsent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                '_id',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Deletes a marketing consent.
 * @param marketingConsentId - ID of the marketing consent to delete.
 * @public
 * @documentationMaturity preview
 * @requiredField marketingConsentId
 * @permissionId MARKETING.CONSENT_DELETE
 * @adminMethod
 */
export function deleteMarketingConsent(marketingConsentId) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { marketingConsentId: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _deleteMarketingConsentRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _deleteMarketingConsentResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([marketingConsentId]);
        const reqOpts = ambassadorWixMarketingMarketingConsentV1MarketingConsent.deleteMarketingConsent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'marketingConsentId',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Removes a marketing consent. The consent is cancelled, and the `state` is updated to `REVOKED`.
 * The marketing consent entity still exists, but the recipient is no longer eligible to receive commmunication.
 * To delete a marketing consent entirely, use Delete Marketing Consent.
 *
 * Required fields:
 * - `details.type`.
 * - `details.email` OR `details.phone`.
 * - `info.lastRevokeActivity`.
 * @param details - Marketing consent communication details.
 * @public
 * @documentationMaturity preview
 * @requiredField details
 * @requiredField details.type
 * @param options - Field options. The `lastRevokeActivity` field **must** be passed.
 * @permissionId MARKETING.CONSENT_UPSERT
 * @adminMethod
 */
export function removeMarketingConsent(details, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            details: '$[0]',
            lastRevokeActivity: '$[1].lastRevokeActivity',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _removeMarketingConsentRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _removeMarketingConsentResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['marketingConsent']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([details, options]);
        const reqOpts = ambassadorWixMarketingMarketingConsentV1MarketingConsent.removeMarketingConsent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'details',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * CreateMarketingConsent the specified marketing_consent in the token
 * @param token - Encrypted token with essential information
 * @internal
 * @documentationMaturity preview
 * @requiredField token
 * @permissionId MARKETING.CONSENT_UPSERT
 * @adminMethod
 */
export function createMarketingConsentByToken(token) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { token: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _createMarketingConsentByTokenRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _createMarketingConsentByTokenResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['marketingConsent']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([token]);
        const reqOpts = ambassadorWixMarketingMarketingConsentV1MarketingConsent.createMarketingConsentByToken(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'token',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * RemoveMarketingConsent the specified marketing_consent in the token
 * @param token - Encrypted token with essential information
 * @internal
 * @documentationMaturity preview
 * @requiredField token
 * @permissionId MARKETING.CONSENT_UPSERT
 * @adminMethod
 */
export function removeMarketingConsentByToken(token) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { token: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _removeMarketingConsentByTokenRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _removeMarketingConsentByTokenResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['marketingConsent']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([token]);
        const reqOpts = ambassadorWixMarketingMarketingConsentV1MarketingConsent.removeMarketingConsentByToken(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'token',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Retrieves a list of marketing consents, given the provided paging, filtering, and sorting. Up to 100 marketing consents can be returned per request.
 *
 * The default `sort` is `id` in `ASC` order. For a detailed list of supported operations, see filtering and sorting for marketing consent properties. To learn how to query marketing consents, see API Query Language.
 * @public
 * @documentationMaturity preview
 * @permissionId MARKETING.CONSENT_READ
 * @adminMethod
 */
export function queryMarketingConsent() {
    const requestTransformation = { '*': '$[1]', query: '$[0]' };
    const responseTransformation = {
        items: '$.marketingConsent',
        pagingMetadata: '$.pagingMetadata',
    };
    // @ts-ignore
    const { httpClient, sideEffects, additionalHeaders } = arguments[0];
    const { toAmbassadorRequest } = serializer({
        rootSchema: _queryMarketingConsentRequest,
        depSchemas: {},
        fqdnTransformation: {
            paths: [],
            transformation: _fromVeloEntity,
        },
        customTransformation: requestTransformation,
    });
    const { fromJSON } = serializer({
        rootSchema: _queryMarketingConsentResponse,
        depSchemas: {},
        fqdnTransformation: {
            paths: [...['Array#marketingConsent']],
            transformation: _toVeloEntity,
        },
        customTransformation: responseTransformation,
    });
    return wrapWithQueryBuilder({
        func: (payload) => __awaiter(this, void 0, void 0, function* () {
            var _a, _b, _c;
            const reqOpts = ambassadorWixMarketingMarketingConsentV1MarketingConsent.queryMarketingConsent(payload);
            const reqOptionWithHeadersWrapper = (args) => {
                const result = reqOpts(args);
                if (additionalHeaders) {
                    const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                    return Object.assign(Object.assign({}, result), { headers });
                }
                return result;
            };
            (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
            try {
                const result = yield httpClient.request(reqOptionWithHeadersWrapper);
                (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
                return result;
            }
            catch (err) {
                (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
                throw err;
            }
        }),
        requestTransformer: (...args) => toAmbassadorRequest(args),
        responseTransformer: ({ data }) => fromJSON(data),
        errorTransformer: (err) => {
            const transformedError = transformError(err, requestTransformation);
            throw transformedError;
        },
        pagingMethod: 'CURSOR',
        transformationPaths: resolveQueryFieldsTransformationPaths(_toVeloEntity),
    })({ cursorWithEmptyFilterAndSort: true });
}
/**
 * Creates or updates a marketing consent.
 * Required fields:
 * - `details.type`.
 * - `details.email` OR `details.phone`.
 * - `state`.
 *
 * When a marketing consent's `state` is `PENDING` or `CONFIRMED`, the `info.lastConfirmationActivity` field is required.
 * When a marketing consent's `state` is `REVOKED`, the `info.lastRevokeActivity` field is required.
 *
 * >**Note:** For existing marketing consents with `{"type": "EMAIL"}`, you can't update the `state` to `UNKNOWN_STATE`. Trying to do so maintains the current state. However, you can create a new marketing consent and set the `state` to `UNKNOWN_STATE`. Note that you can't create more than a single consent per email or phone number.
 * @param marketingConsent - Marketing consent to create or update.
 * @public
 * @documentationMaturity preview
 * @requiredField marketingConsent
 * @requiredField marketingConsent.details
 * @requiredField marketingConsent.details.type
 * @permissionId MARKETING.CONSENT_UPSERT
 * @adminMethod
 */
export function upsertMarketingConsent(marketingConsent) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { marketingConsent: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _upsertMarketingConsentRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['marketingConsent']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _upsertMarketingConsentResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['marketingConsent']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([marketingConsent]);
        const reqOpts = ambassadorWixMarketingMarketingConsentV1MarketingConsent.upsertMarketingConsent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'marketingConsent',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates or updates multiple marketing consents.
 * Required fields:
 * - `details.type`.
 * - `details.email` OR `details.phone`.
 * - `state`.
 *
 * When a marketing consent's `state` is `PENDING` or `CONFIRMED`, the `info.lastConfirmationActivity` field is required.
 * When a marketing consent's `state` is `REVOKED`, the `info.lastRevokeActivity` field is required.
 *
 * >**Note:** For existing marketing consents with `{"type": "EMAIL"}`, you can't update the `state` to `UNKNOWN_STATE`. Trying to do so maintains the current state. However, you can create a new marketing consent and set the `state` to `UNKNOWN_STATE`. Note that you can't create more than a single consent per email or phone number.
 * @param info - List of marketing consent information to update or create.
 * @public
 * @documentationMaturity preview
 * @requiredField info
 * @requiredField info.details
 * @permissionId MARKETING.CONSENT_UPSERT
 * @adminMethod
 */
export function bulkUpsertMarketingConsent(info) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = { info: '$[0]' };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[1];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _bulkUpsertMarketingConsentRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#info']],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _bulkUpsertMarketingConsentResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [...['Array#results.marketingConsent']],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([info]);
        const reqOpts = ambassadorWixMarketingMarketingConsentV1MarketingConsent.bulkUpsertMarketingConsent(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'info',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
/**
 * Creates an unsubscribe link to be shared with the relevant recipient.
 *
 * If someone clicks the **Unsubscribe** button on the confirmation page,
 * the recipient's `subscriptionStatus` is changed to `UNSUBSCRIBED`.
 * @param type - The communication channel of the marketing consent.
 * @internal
 * @documentationMaturity preview
 * @requiredField options.linkType
 * @requiredField type
 * @permissionId MARKETING.CONSENT_READ
 * @adminMethod
 */
export function generateLink(type, options) {
    var _a, _b, _c;
    return __awaiter(this, arguments, void 0, function* () {
        const requestTransformation = {
            type: '$[0]',
            email: '$[1].email',
            phone: '$[1].phone',
            linkType: '$[1].linkType',
            language: '$[1].language',
            metadata: '$[1].metadata',
        };
        const responseTransformation = '$';
        // @ts-ignore
        const { httpClient, sideEffects, additionalHeaders } = arguments[2];
        const { toAmbassadorRequest } = serializer({
            rootSchema: _generateLinkRequest,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _fromVeloEntity,
            },
            customTransformation: requestTransformation,
        });
        const { fromJSON } = serializer({
            rootSchema: _generateLinkResponse,
            depSchemas: {},
            fqdnTransformation: {
                paths: [],
                transformation: _toVeloEntity,
            },
            customTransformation: responseTransformation,
        });
        const payload = toAmbassadorRequest([type, options]);
        const reqOpts = ambassadorWixMarketingMarketingConsentV1MarketingConsent.generateLink(payload);
        const reqOptionWithHeadersWrapper = (args) => {
            const result = reqOpts(args);
            if (additionalHeaders) {
                const headers = Object.assign(Object.assign({}, (result.hasOwnProperty('headers') ? result.headers : {})), additionalHeaders);
                return Object.assign(Object.assign({}, result), { headers });
            }
            return result;
        };
        (_a = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSiteCall) === null || _a === void 0 ? void 0 : _a.call(sideEffects);
        try {
            const result = yield httpClient.request(reqOptionWithHeadersWrapper);
            (_b = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onSuccess) === null || _b === void 0 ? void 0 : _b.call(sideEffects, result);
            return fromJSON(result.data);
        }
        catch (err) {
            const transformedError = transformError(err, requestTransformation, [
                'type',
                'options',
            ]);
            (_c = sideEffects === null || sideEffects === void 0 ? void 0 : sideEffects.onError) === null || _c === void 0 ? void 0 : _c.call(sideEffects, err);
            throw transformedError;
        }
    });
}
//# sourceMappingURL=marketing-marketing-consent-v1-marketing-consent.universal.js.map